import Vue from "vue";
import ADropdown from "+/components/dropdown/Dropdown";

export const dropdownFormatter = function(cell) {
  // add custom class so we can remove 'overflow:hidden'
  cell.getElement().classList.add("action-col");
  // render vue component
  let ComponentClass = Vue.extend(ADropdown);
  let instance = new ComponentClass({
    propsData: {
      dropdownActions: cell.getValue(),
      triggerClass: "btn btn-pf-secondary btn-pf-dropdown btn-dropdown-loader",
      icon: "pf-dropdown-loader"
    }
  });
  instance.$mount();
  return instance.$el;
};
